var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ghost-btn",on:{"click":function($event){return _vm.$emit('clicked')}}},[_c('div',{staticClass:"copy"},[_vm._v(_vm._s(_vm.copy))])])
}
var staticRenderFns = []

export { render, staticRenderFns }